// extracted by mini-css-extract-plugin
export default {"blurAwareContainer":"BlurAwareContainer_blurAwareContainer__540OV","fullWidth":"BlurAwareContainer_fullWidth__w02vf"};